import RenterInfoExpandCTA from './RenterInfoExpandCTA';

export default RenterInfoExpandCTA;
